const PrivacyPolicy = () => {
    return (
      <div className="container mx-auto mt-[100px] md:mt-[200px] 2xl:mt-[250px] px-[50px] sm:px-[100px] xl:px-[250px] 2xl:px-[300px] pb-[50px]">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold font-playfair text-center mb-[50px]">Privacy Policy for Symphonys Artisanal Bakery</h1>
        <p className="text-[16px] font-medium font-montserrat mb-4">
          At Symphony’s Artisanal Bakery ("Symphonys," "we," "our," or "us"), we
          respect your privacy and are committed to protecting it through our
          compliance with this policy. This Privacy Policy explains how we
          collect, use, disclose, and safeguard your information when you visit
          our website www.thesymphonys.com (the "Website").
        </p>
        <h2 className="text-2xl font-playfair font-semibold mb-4">Information We Collect</h2>
        <ul className="list-decimal ml-10 mb-4 text-[16px] font-medium font-montserrat">
          <li>
            <strong>Personal Data:</strong> <br></br> 
            Information you voluntarily provide,
            such as your name, email address, phone number, and shipping address,
            when you sign up for our newsletter, make a purchase, or contact us.
          </li>
          <li>
            <strong>Non-Personal Data:</strong> <br></br> 
            Data automatically collected when
            you visit our Website, such as your IP address, browser type,
            operating system, and browsing behavior.
          </li>
          <li>
            <strong>Cookies and Tracking Technologies:</strong> <br></br> 
            We may use
            cookies, web beacons, and similar technologies to enhance your
            experience and analyze Website usage.
          </li>
        </ul>
        <h2 className="text-2xl font-playfair font-semibold mb-4">How We Use Your Information</h2>
        <p className="mb-4 text-[16px] font-medium font-montserrat">
            We use the information we collect for various purposes, including to:
        </p>
        <ul className="list-disc ml-10 mb-4 text-[16px] font-medium font-montserrat">
          <li>Process and fulfill your orders.</li>
          <li>Respond to your inquiries and provide customer support.</li>
          <li>Send you promotional emails and updates (with your consent).</li>
          <li>Improve our Website, products, and services.</li>
          <li>Analyze Website traffic and user behavior.</li>
          <li>Comply with legal obligations and protect our rights.</li>
        </ul>
        <h2 className="text-2xl font-playfair font-semibold mb-4">How We Share Your Information</h2>
        <p className="mb-4 text-[16px] font-medium font-montserrat">
          We do not sell your personal information to third parties. However, we
          may share your information with:
        </p>
        <ul className="list-disc ml-10 mb-4 text-[16px] font-medium font-montserrat">
          <li>
            <strong>Service Providers:</strong> Trusted third-party vendors who
            help us operate our Website and provide services (e.g., payment
            processors, delivery services).
          </li>
          <li>
            <strong>Legal Compliance:</strong> Authorities when required to
            comply with legal obligations or protect our rights.
          </li>
          <li>
            <strong>Business Transfers:</strong> In connection with mergers,
            acquisitions, or the sale of our business assets.
          </li>
        </ul>
        <h2 className="text-2xl font-playfair font-semibold mb-4">Your Choices and Rights</h2>
        <ul className="list-disc ml-10 mb-4 text-[16px] font-medium font-montserrat">
          <li>
            <strong>Access and Update:</strong> You can access and update your
            personal information by logging into your account or contacting us
            directly.
          </li>
          <li>
            <strong>Marketing Communications:</strong> You may opt out of
            receiving promotional emails by clicking the "unsubscribe" link in any
            email or contacting us.
          </li>
          <li>
            <strong>Cookies:</strong> You can manage your cookie preferences
            through your browser settings.
          </li>
        </ul>
        <h2 className="text-2xl font-playfair font-semibold mb-4">Data Security</h2>
        <p className="mb-4 text-[16px] font-medium font-montserrat">
          We implement appropriate technical and organizational measures to
          protect your personal data from unauthorized access, use, alteration, or
          disclosure. However, no data transmission or storage system can be
          guaranteed to be 100% secure.
        </p>
        <h2 className="text-2xl font-playfair font-semibold mb-4">Third-Party Links</h2>
        <p className="mb-4 text-[16px] font-medium font-montserrat">
          Our Website may contain links to third-party websites. We are not
          responsible for the privacy practices or content of such websites. We
          encourage you to review their privacy policies before providing any
          personal information.
        </p>
        <h2 className="text-2xl font-playfair font-semibold mb-4">Children’s Privacy</h2>
        <p className="mb-4 text-[16px] font-medium font-montserrat">
          Our Website is not intended for children under 13 years of age. We do
          not knowingly collect personal information from children under 13. If we
          learn we have collected or received personal information from a child
          under 13 without parental consent, we will delete it.
        </p>
        <h2 className="text-2xl font-playfair font-semibold mb-4">Changes to This Privacy Policy</h2>
        <p className="mb-4 text-[16px] font-medium font-montserrat">
          We may update this Privacy Policy from time to time. Any changes will be
          effective immediately upon posting the revised policy on the Website.
          Your continued use of the Website following the posting of changes
          constitutes your acceptance of such changes.
        </p>
        <h2 className="text-2xl font-playfair font-semibold mb-4">Contact Us</h2>
        <p className="mb-4 text-[16px] font-medium font-montserrat">
          If you have any questions or concerns about this Privacy Policy or our
          practices, please contact us:
        </p>
        <ul className="list-disc ml-10 mb-4 text-[16px] font-medium font-montserrat">
          <li>Email: info@thesymphonys.com</li>
          <li>Phone: +974 41487722</li>
          <li>Mail: P.O.Box 16157, City Center Doha, West Bay, Doha, Qatar</li>
        </ul>
        <p className="text-center mt-6 text-[16px] font-medium font-montserrat">
          Thank you for trusting Symphony’s Artisanal Bakery with your personal
          information.
        </p>
      </div>
    );
  };
  
  export default PrivacyPolicy;
  